import { io, type Socket } from 'socket.io-client'
import { resolveWebchatUrl } from '~/components/Webchat/resolveWebchatUrl'

export type WebchatAuth = {
  token?: string
  locale?: string // 'ru' | 'ro'
  path?: string // current page, locale-stripped
}

export function createWebchatSocket(auth: WebchatAuth): Socket {
  const url = resolveWebchatUrl(
    import.meta.env.VITE_WEBCHAT_URL as string | undefined,
  )
  return io(url, {
    path: '/socket.io',
    transports: ['websocket'],
    auth,
  })
}
